import { styled, Box } from '@mui/material';

var PREFIX = "FormatTechnicalFields";
var classes = {
    root: "".concat(PREFIX, "-root"),
    field: "".concat(PREFIX, "-field"),
    mediaType: "".concat(PREFIX, "-mediaType"),
    folder: "".concat(PREFIX, "-folder")
};
var StyledFormatTechnicalFields = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.root)] = {
            display: "flex",
            flexWrap: "wrap",
            gap: theme.spacing(0.5)
        },
        _b["& .".concat(classes.field)] = {
            background: theme.palette.grey[200],
            padding: theme.spacing(0, 0.5),
            borderRadius: "3px"
        },
        _b["& .".concat(classes.mediaType)] = {
            textTransform: "uppercase"
        },
        _b["& .".concat(classes.folder)] = {
            textTransform: "capitalize",
            color: "inherit",
            paddingLeft: theme.spacing(0.9),
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            verticalAlign: "bottom",
            minWidth: "inherit",
            "& .MuiButton-startIcon": {
                marginRight: theme.spacing(0.5)
            }
        },
        _b);
});

export { PREFIX, StyledFormatTechnicalFields, classes };
//# sourceMappingURL=styles.js.map
